import React, { useState } from 'react';
import PropTypes from 'prop-types';
import isObject from 'lodash/isObject';
import get from 'lodash/get';
import { useSelector } from 'react-redux';

import './faqs.m.css';
import { isMobile } from 'react-device-detect';
import { getUserStatus } from '../../../../helpers/utils';

const FAQItem = (props) => {
  const userData = useSelector((state) => get(state, ['userData']));
  const { question, answer, index } = props.item;

  const [isOpen, setIsOpen] = useState(false);

  const handleAccordionClick = () => {
    const selectType = isOpen ? 'collapse' : 'expand';
    setIsOpen(!isOpen);

    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({
        event: 'accordion_interaction',
        cta_text: question || 'NA',
        select_type: selectType || 'NA',
        page_template: 'section-page',
        user_id: userData?.userProfile?.userId || 'NA',
        user_status: getUserStatus(),
        login_type: userData?.isLoggedIn ? 'logged-in' : 'logged-out',
        language_hit: 'english',
        Platform: isMobile ? 'mobile' : 'desktop',
        SiteName: 'www.ndtvprofit.com'
      });
    } else {
      console.error('Error: window.dataLayer is not available');
    }
  };

  return (
    <div styleName="pn-tab">
      <input id={`tab1${index + 1}`} type="checkbox" name="tabs" checked={isOpen} readOnly />
      <div styleName="pn-tab-wrapper">
        <label htmlFor={`tab1${index + 1}`} onClick={handleAccordionClick}>
          {question}
        </label>
        {isOpen && (
          <div styleName="pn-tab-content">
            {isObject(answer) ? (
              <div styleName="pn-tab-content-wrapper">
                <div styleName="answer" dangerouslySetInnerHTML={{ __html: answer.description }} />
                <ul>
                  {answer.points.map((point, index) => (
                    <li key={index}>
                      <div dangerouslySetInnerHTML={{ __html: point.item }} />
                    </li>
                  ))}
                </ul>
              </div>
            ) : (
              <div styleName="pn-tab-content-wrapper">
                <div styleName="answer" dangerouslySetInnerHTML={{ __html: answer }} />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

FAQItem.propTypes = {
  item: PropTypes.object.isRequired
};
export default FAQItem;
